import { AnyAction } from '@reduxjs/toolkit';
import { map, Observable } from 'rxjs';

export function mapPayload() {
  return <T extends AnyAction>(source: Observable<T>): Observable<T['payload']> =>
    source.pipe(map(({ payload }) => payload));
}
